<template>
  <div class="content">
    <product-form-modal :product="dataall"></product-form-modal>
    <unit></unit>
    <extraunit></extraunit>
    <model></model>
    <brand></brand>
    <colour></colour>
    <country></country>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.product.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ProductFormModal, Unit,Extraunit,Model, Brand, Colour, Country } from "@/pages";
export default {
  components: { ProductFormModal, Unit,Extraunit, Model, Brand, Colour, Country },
  data() {
    return {
      dataall: {
        name: "",
        see:true,
        unit_id: 0,
        extra_unit_id1: 0,
        extra_unit_id2: 0,
        parent_id: 0,
        is_folder: 0,
        model_id: 0,
        model_ids: [],
        country_id: 0,
        minimum_amount:1,
        brand_id: 0,
        colour_id: 0,
        quality: "",
        number:0,
        picture_name: null,
        extra_name: "",
        pack_count:1,
        shtrix_table: [{ shtrix_kod: "" }]
      }
    };
  },
   created: function() {
    let self=this;
    axios
        .get("api/v1/product/last-number")
        .then(function(response) {
            self.dataall.number=response.data.number;
        });
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Товар" });
      }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
